var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIdcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "39px",
    viewBox: "0 0 49 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phase2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phase02_UI_navigation",
    transform: "translate(-169.000000, -642.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(146.000000, 630.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(24.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 47,
    height: 36.3508772,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.22222222,
    y1: 29.8596491,
    x2: 28.7222222,
    y2: 29.8596491,
    id: "Line-2-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.22222222,
    y1: 24.6666667,
    x2: 37.8611111,
    y2: 24.6666667,
    id: "Line-2-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    x: 29.7222222,
    y: 6.19298246,
    width: 11.0555556,
    height: 10.9824561,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3976608,6.19298246 L11.4444444,6.19298246 L11.4444444,17.1754386 L14.3976608,17.1754386 C15.9140216,17.1754386 17.2868286,16.560812 18.2805454,15.5670951 C19.2742623,14.5733783 19.8888889,13.2005713 19.8888889,11.6842105 C19.8888889,10.1678498 19.2742623,8.79504275 18.2805454,7.80132592 C17.2868286,6.80760909 15.9140216,6.19298246 14.3976608,6.19298246 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 5.875,
    y: 5.19298246,
    width: 1.95833333,
    height: 12.9824561
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIdcard);
export default __webpack_public_path__ + "static/media/menu-idcard.14bef89ae880b1f90cbbdf8fbb850877.svg";
export { ForwardRef as ReactComponent };